import every from "lodash/every";
import isEqual from "lodash/isEqual";

export const SOW_FIELD = "sowField";
export const DOCUMENT_FIELD = "documentField";
export const DATE_FIELD = "dateField";
export const BASIC_CONFIRMATION_FIELD = "basicConfirmationField";
export const CONTRACT_SUPPLIER_INDIVIDUALS_FIELD =
  "contractSupplierIndividualsField";
export const WFM_PROFILE_ID_FIELD = "wfmProfileIdField";
export const PEOPLENET_ID_FIELD = "peoplenetIdField";
export const TEXT_FIELD = "textField";

export const EITHER_PARTY = "either_party";
export const EMPLOYER = "my_company";
export const AGENCY = "staffing_firm";
export const BOTH_PARTIES = "both_parties";

export function determineChecklistItemType(checklistItem) {
  if (checklistItem.name === "Statement of Services") return SOW_FIELD;

  if (checklistItem.name === "WFM Profile ID") return WFM_PROFILE_ID_FIELD;

  if (checklistItem.name === "Peoplenet ID") return PEOPLENET_ID_FIELD;

  if (checklistItem.prerequisiteType) {
    switch (checklistItem.prerequisiteType) {
      case "document":
        return DOCUMENT_FIELD;
      case "date":
        return DATE_FIELD;
      case "submitters":
        return CONTRACT_SUPPLIER_INDIVIDUALS_FIELD;
      case "text":
        return TEXT_FIELD;
      case "basic":
      default:
        return BASIC_CONFIRMATION_FIELD;
    }
  }

  if (checklistItem.documentRequired) {
    return DOCUMENT_FIELD;
  }

  if (checklistItem.requestedDate) {
    return DATE_FIELD;
  }

  if (checklistItem.contractSupplierIndividualsRequired) {
    return CONTRACT_SUPPLIER_INDIVIDUALS_FIELD;
  }

  return BASIC_CONFIRMATION_FIELD;
}

export const checkResponsibility = ({
  employerConfirmedAt,
  agencyConfirmedAt,
  responsibility,
}) => {
  switch (responsibility) {
    case BOTH_PARTIES:
      return Boolean(employerConfirmedAt && agencyConfirmedAt);
    case EMPLOYER:
      return Boolean(employerConfirmedAt);
    case AGENCY:
      return Boolean(agencyConfirmedAt);
    case EITHER_PARTY:
    default:
      return Boolean(employerConfirmedAt || agencyConfirmedAt);
  }
};

const checkBasicConfirmed = (item, individual) => {
  const { responsibility } = item;
  const employerConfirmedAt = individual.employer
    ? item.basicConfirmed
    : item.employerConfirmedAt;
  const agencyConfirmedAt = individual.recruiter
    ? item.basicConfirmed
    : item.agencyConfirmedAt;

  return checkResponsibility({
    employerConfirmedAt,
    agencyConfirmedAt,
    responsibility,
  });
};

export function detectChecklistItemChange(prevItem, currItem) {
  const type = determineChecklistItemType(prevItem);

  if (type !== determineChecklistItemType(currItem)) {
    return false;
  }

  switch (type) {
    case WFM_PROFILE_ID_FIELD:
      return (
        (prevItem.wfmProfileId !== currItem.wfmProfileId &&
          currItem.basicConfirmed) ||
        (prevItem.wfmProfileId && !currItem.wfmProfileId)
      );
    default:
      return !isEqual(prevItem, currItem);
  }
}

export function checklistItemComplete(item, currentIndividual) {
  const type = determineChecklistItemType(item);
  switch (type) {
    case SOW_FIELD:
      return Boolean(item.agencyConfirmedAt && item.employerConfirmedAt);
    case WFM_PROFILE_ID_FIELD:
      return Boolean(item.wfmProfileId && item.basicConfirmed);
    case PEOPLENET_ID_FIELD:
      return Boolean(item.peoplenetId && item.basicConfirmed);
    case DOCUMENT_FIELD:
      return Boolean(item.document);
    case DATE_FIELD:
      return Boolean(item.submittedDate);
    case TEXT_FIELD:
      return Boolean(item.textValue);
    case CONTRACT_SUPPLIER_INDIVIDUALS_FIELD:
      return (
        Boolean(currentIndividual.employer && item.agencyConfirmedAt) ||
        Boolean(item.contractSupplierIndividuals.length)
      );
    case BASIC_CONFIRMATION_FIELD:
    default:
      return checkBasicConfirmed(item, currentIndividual);
  }
}

export function allChecklistItemsComplete(checklistItems, currentIndividual) {
  return every(checklistItems, (item) =>
    checklistItemComplete(item, currentIndividual)
  );
}
